/**
 * 14 カテゴリの ID と表示名。
 * docs/CATEGORIES.md と同期 (変更時は両方同時更新)。
 */

import type { CategoryId, CategoryName } from '@shared/types';

export interface CategoryInfo {
  readonly id: CategoryId;
  readonly name: CategoryName;
  readonly displayName: string;
}

export const CATEGORIES: ReadonlyArray<CategoryInfo> = [
  { id: 1, name: 'hero', displayName: '外装メイン写真 (ヒーロー)' },
  { id: 2, name: 'exterior_front', displayName: '外装・正面' },
  { id: 3, name: 'exterior_side', displayName: '外装・側面' },
  { id: 4, name: 'exterior_rear', displayName: '外装・後方' },
  { id: 5, name: 'exterior_diagonal', displayName: '外装・斜め' },
  { id: 6, name: 'interior_driver', displayName: '運転席' },
  { id: 7, name: 'interior_dashboard', displayName: 'ダッシュボード' },
  { id: 8, name: 'interior_rear_seat', displayName: '後部座席' },
  { id: 9, name: 'luggage', displayName: 'ラゲッジ・トランク' },
  { id: 10, name: 'engine', displayName: 'エンジンルーム' },
  { id: 11, name: 'wheel_tire', displayName: 'タイヤ・ホイール' },
  { id: 12, name: 'meter', displayName: 'メーター・ディスプレイ' },
  { id: 13, name: 'navigation', displayName: 'ナビ・オーディオ' },
  { id: 14, name: 'equipment_detail', displayName: '装備アップ・書類・その他' },
] as const;

const ID_TO_NAME = new Map<CategoryId, CategoryName>(CATEGORIES.map((c) => [c.id, c.name]));

export function nameOf(id: CategoryId): CategoryName {
  const name = ID_TO_NAME.get(id);
  if (!name) throw new RangeError(`Unknown CategoryId: ${id}`);
  return name;
}

export function isValidCategoryId(value: unknown): value is CategoryId {
  return (
    typeof value === 'number' && Number.isInteger(value) && value >= 1 && value <= CATEGORIES.length
  );
}
